$(document).ready(function() {
  $('.js-promo__container__upsell__skip').click(function(event){
    event.preventDefault();
    window.parent.postMessage('closeDialog', '*');
  });
});
